import _ from 'lodash';
import moment from 'moment';

export const sanitize = (input, orderBy, colNames) => {
  const col = colNames.find(v=>(v.id===orderBy));
  if (col && col.type === 'number') {
    return parseInt(_.get(input, orderBy));
  } else if (col && col.type === 'date') {
    return _.get(input, orderBy) && moment(_.get(input, orderBy)).format('YYYYMMDD');
  }
  return _.get(input, orderBy);
}

export const desc = (x, y, orderBy, colNames) => {
  const a = sanitize(x, orderBy, colNames);
  const b = sanitize(y, orderBy, colNames);

  if (b < a) {
    return -1;
  }
  if (b > a) {
    return 1;
  }
  return 0;
}

export const stableSort = (array, cmp) => {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = cmp(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map(el => el[0]);
}

export const getSorting = (order, orderBy, colNames) => {
  return order === 'desc' ? (a, b) => desc(a, b, orderBy, colNames) : (a, b) => -desc(a, b, orderBy, colNames);
}



// WEBPACK FOOTER //
// ./src/utils/table.js